var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCalendarSelected = function SvgCalendarSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01 16.622l2.252 2.252 4.991-4.99a.687.687 0 01.968 0 .687.687 0 010 .968l-5.474 5.474a.685.685 0 01-.968 0l-2.736-2.737a.684.684 0 01.967-.967zm13.884-8.41H1.368v15.736c0 .378.306.684.684.684H21.21a.683.683 0 00.684-.684V8.211zm-2.737-5.474h2.053a2.05 2.05 0 012.052 2.052v19.158a2.051 2.051 0 01-2.052 2.053H2.052a2.053 2.053 0 01-2.053-2.053V4.79c0-1.134.919-2.052 2.053-2.052h2.053V.685c0-.38.306-.684.684-.684.379 0 .684.305.684.684v2.053h5.474V.685c0-.38.306-.684.684-.684.379 0 .684.305.684.684v2.053h5.474V.685c0-.38.306-.684.684-.684.38 0 .684.305.684.684v2.053zm0 1.368v.684a.683.683 0 11-1.368 0v-.684h-5.474v.684a.683.683 0 11-1.368 0v-.684H5.473v.684a.683.683 0 11-1.368 0v-.684H2.052a.683.683 0 00-.684.684v2.053h20.526V4.79a.682.682 0 00-.684-.684h-2.053z",
    fill: "currentColor",
    fillRule: "evenodd",
    opacity: 0.87
  })));
};

export default SvgCalendarSelected;